import {
  PostChangePartnerResponseType,
  PostChangePartnerServerResponseType,
} from './types';

export const transformChangePartnerResponse = (
  response: PostChangePartnerServerResponseType
): PostChangePartnerResponseType => {
  return {
    newPartnerId: response.result.new_partner.id,
  };
};
